import { AddShiftComponent } from './add-shift/add-shift.component';
import { EditShiftComponent } from './edit-shift/edit-shift.component';
import { ListShiftComponent } from './list-shift/list-shift.component';
import { SingleViewShiftComponent } from './list-shift/single-view-shift';

export const ShiftDeclaration = [
    AddShiftComponent,
    ListShiftComponent,
    EditShiftComponent,
    SingleViewShiftComponent
];
